import React from 'react'

const PrivacyPolicy = () => {
    return (
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col gap-8'>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                Privacy Policy
            </h2>
            <div className='flex flex-col gap-4'>
                <p className="text-md text-gray-600 font-bold leading-relaxed">
                    Last updated: 2025-06-01
                </p>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    At NEWLINE INFOTECH PRIVATE LIMITED (NIPL), we understand the importance of privacy in the digital world, especially when working with financial institutions and their end-users. This Privacy Policy describes how we collect, use, share, and protect the information of clients and users when interacting with our websites, applications, products, or services. By choosing to engage with NIPL, you agree to the terms of this policy.
                </p>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    NIPL develops and manages digital solutions—including web platforms, mobile applications, and backend systems—for financial institutions such as NBFCs, fintech startups, banks, insurance providers, and wealth management companies. In the course of our work, we may collect information from our clients (financial organizations) as well as limited technical or usage data from their end-users, depending on the services provided.
                </p>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    For clients and partners, we may collect personal and professional information such as names, contact details, business identification numbers, payment information, and technical requirements to deliver our services effectively. When we develop or maintain systems that process end-user data (e.g., for loan applications, investment portals, or mobile banking apps), we do so as a data processor on behalf of our clients, who remain the data controllers responsible for how user data is collected and used.
                </p>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    Our role primarily involves providing secure, scalable, and compliant digital infrastructure. In some cases, we may access technical data such as server logs, device information, crash reports, and anonymous user behavior analytics to help our clients improve performance and usability. We do not access or use sensitive end-user financial or personal data unless explicitly required for development, debugging, or support purposes—and even then, only under strict non-disclosure and security agreements.
                </p>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    We are committed to maintaining industry-standard security practices, including encryption, secure authentication, network firewalls, and access control policies. NIPL also adheres to relevant data protection regulations such as the Indian DPDP Act, and, where applicable, global standards like GDPR. Any access to confidential client or user information is governed by contractual agreements, and we ensure that our development and support teams follow secure coding and privacy-first protocols.
                </p>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    We do not sell or misuse any data entrusted to us. Any third-party service providers we use—such as cloud platforms, analytics tools, or testing services—are carefully vetted and comply with privacy standards aligned with our own. We ensure that all subcontractors are bound by confidentiality agreements and use data only for the intended technical purpose.
                </p>
                <p className="text-md text-gray-600 leading-relaxed">
                    <b>1. Information We Collect</b> <br />
                    We may collect information about you in a variety of ways. The information we may collect via the App includes:
                </p>
                <p className="text-md text-gray-600 leading-relaxed">
                    a. Personal Data <br />
                    Personally identifiable information (such as your name, email address, and phone number) that you voluntarily give to us when you register within the App, subscribe to a service, or communicate with us.
                    <br />
                    b. Usage Data<br />
                    Information automatically collected when you access the App, including your device’s IP address, browser type, operating system, app usage data, access times, and referring website addresses.
                    <br />
                    c. Device Data<br />
                    Information about your device, such as your mobile device ID, model, manufacturer, and operating system version.
                    <br />
                    d. Location Data<br />
                    We may collect data related to your location if you enable location services for the App.
                </p>

                <p className="text-md text-gray-600 leading-relaxed">
                    <b>2. How We Use Your Information</b> <br />
                    We use the information we collect to:<br />

                    Provide and maintain our App.<br />

                    Improve, personalize, and expand our App.<br />

                    Analyze how users interact with the App.<br />

                    Develop new products, services, features, and functionality.<br />

                    Communicate with you for customer service, updates, and promotional purposes.<br />

                    Protect against illegal activities and security threats.<br />

                    Comply with legal requirements.
                </p>

                <p className="text-md text-gray-600 leading-relaxed">
                    <b>3. Sharing Your Information</b> <br />
                    We do not share your personal information with third parties, except in the following circumstances: <br />

                    With service providers who perform functions on our behalf (e.g., data storage, analytics).<br />

                    To comply with legal obligations or protect the rights, property, or safety of [App Name], our users, or others.<br />

                    In connection with a merger, sale, or acquisition of our company.<br />
                </p>
                <p className="text-md text-gray-600 leading-relaxed">
                    <b>4. Data Security</b> <br />
                    We use a variety of security measures to ensure the protection of your personal information. However, please note that no method of electronic transmission or storage is completely secure.
                </p>

                <p className="text-md text-gray-600 leading-relaxed">
                    <b>5. Third-Party Links</b> <br />
                    Our App may contain links to third-party websites or services that are not operated by us. We are not responsible for the privacy practices of these third parties, and we encourage you to review their privacy policies.
                </p>

                <p className="text-md text-gray-600 leading-relaxed">
                    <b>6. Your Data Rights</b> <br />
                    Depending on your location, you may have the following rights: <br />
                    Access, correct, or delete your personal information. <br />
                    Restrict or object to our processing of your data. <br />
                    Data portability. <br />
                    Withdraw consent at any time (if the processing is based on consent). <br />
                    If you wish to exercise these rights, please contact us at support@nipl.in.
                </p>

                <p className="text-md text-gray-600 leading-relaxed">
                    <b>7. Children’s Privacy</b> <br />
                    Our App is not intended for children under 13 years of age, and we do not knowingly collect personal information from children under 13. If we discover that we have collected such information, we will take immediate steps to delete it.
                </p>

                <p className="text-md text-gray-600 leading-relaxed">
                    <b>8. Changes to This Privacy Policy</b> <br />
                    We may update this privacy policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this policy periodically to stay informed.
                </p>

                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    If you are a client of NIPL or an end-user whose data may be indirectly involved in our development process, and you have any concerns regarding privacy or data handling, we encourage you to reach out to us directly. We are committed to maintaining transparency and protecting the trust placed in us.
                </p>
                <br />

                <div className='flex flex-col gap-4'>
                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>Refund Policy</b>
                        <br />
                        At New Line Infotech Private Limited, customer satisfaction is our priority. As our services are customized and digital in nature, we follow a limited and transparent refund policy.
                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>1. No Automatic Refunds</b><br />
                        All payments made for services including website design, development, software solutions, digital marketing, consultation, or any IT-related services are non-refundable once the project has started.
                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>2. Eligible Refund Cases</b><br />
                        A refund request may be considered only if: <br />
                        •	The service has not been started<br />
                        •	No design, development, or consultation work has been initiated<br />
                        •	The request is made within 48 hours of payment
                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>3. Non-Refundable Cases</b><br />
                        No refund will be provided in the following situations: <br />
                        •	Once the project has started<br />
                        •	After demo, draft, or partial delivery<br />
                        •	Delay due to client’s side<br />
                        •	Change of mind or business decision<br />
                        •	Third-party costs like hosting, domains, tools, or software purchases

                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b> 4. Refund Method & Timeline</b><br />

                        If a refund is approved: <br />
                        •	It will be processed to the original payment method only.<br />
                        •	The processing time will be 7–10 business days.<br />
                    </p>
                </div>

                <div className='flex flex-col gap-4'>
                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>Terms and Conditions</b><br />
                        These Terms and Conditions (“Terms”) govern the use of services provided by New Line Infotech Private Limited (“Company”, “we”, “our”, “us”)
                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        By accessing our website or using any of our services, you agree to be bound by these Terms. If you do not agree, please discontinue use immediately.
                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>1. About Us</b><br />
                        New Line Infotech Private Limited is a company incorporated under the Companies Act, 2013, engaged in providing IT services including but not limited to website development, software development, mobile app development, digital marketing, and IT consulting services.

                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>2. Services</b><br />
                        The Company provides custom IT and software-related services as agreed in written proposals, emails, or service-level agreements shared with the client. The scope of work, timelines, and pricing will be finalized before project commencement.
                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>3. Payments</b><br />
                        •	Clients must pay the agreed fees as per the quotation or invoice issued. <br />
                        •	Any delay in payment may result in a pause or termination of the project<br />
                        •	All prices are exclusive of applicable taxes unless stated otherwise.
                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b> 4. Client Responsibilities</b><br />
                        The client agrees to: <br />
                        •	Provide accurate information and required materials in a timely manner<br />
                        •	Cooperate during the project development phase<br />
                        •	Ensure legality of content provided (no copyright violations, illegal material, etc.)<br />

                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>5. Intellectual Property Rights</b><br />
                        Unless otherwise specified: <br />
                        •	All custom designs, code, software, content, or products developed remain the intellectual property of the Company until full payment is made. <br />
                        •	After full payment, ownership may be transferred as agreed in writing. <br />

                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>6. Confidentiality</b><br />

                        We will maintain strict confidentiality of any information or data shared by the client and expect the same in return.

                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b> 7. Limitation of Liability</b><br />

                        We shall not be liable for: <br />
                        •	Any indirect, incidental, or consequential damages<br />
                        •	Loss of profit, data, or business<br />
                        •	Any issues caused by third-party platforms or services<br />
                        Our liability, if any, shall be limited to the total amount paid for the services.



                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>8. Third-Party Services
                        </b><br />
                        We are not responsible for outages, errors, or policy changes of third-party platforms such as hosting providers, payment gateways, domain registrars, etc.

                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>9. Termination</b><br />
                        We reserve the right to suspend or terminate a client’s services in case of: <br />
                        •	Violation of these Terms<br />
                        •	Non-payment<br />
                        •	Illegal or harmful activities<br />

                        Clients may also request termination via written notice.

                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>10. Changes to Terms</b><br />
                        We reserve the right to modify these Terms at any time. Updated Terms will be posted on our website and will become effective immediately.
                    </p>

                    <p className="text-md text-gray-600 leading-relaxed">
                        <b>11. Governing Law
                        </b><br />
                        These Terms shall be governed by the laws of India, and any disputes shall be subject to the jurisdiction of Rajasthan Courts only.
                    </p>

                </div>
                <p className="text-md text-gray-600 leading-relaxed">
                    <b>Contact Information</b><br />
                    For any queries regarding these Terms, please contact: <br />
                    NEWINE INFOTECH PRIVATE LIMITED<br />
                    Email: support@nipl.in<br />
                    Phone: 9352515824<br />
                    Address: 47 Panchwati Saheli Marg,<br />
                    Udaipur, Rajasthan – 313001
                </p>

            </div>
        </div>
    )
}

export default PrivacyPolicy
